'use strict';

module.exports = /*@ngInject*/
function() {
    return function(input) {
        var out;
        var i;

        if (input) {
            for (i in input) {
                if (input[i] < out || out === undefined || out === null) {
                    out = input[i];
                }
            }
        }

        return out;
    };
};
